module.exports = __webpack_public_path__ + "img/list38.ba5d250b.jpeg";